<section>
    <div class="row pt-4  mb-4 w-100">
        <div class="text-right" style="position: relative; width: 100%">
            <div class="d-flex justify-content-end top-div-button">
                <button mat-stroked-button color="primary" class="mr-2 custom-button-icon" type="button"
                    (click)="openDialogProcedure(2, $event)">
                    <mat-icon class="mr-0">add_circle</mat-icon>
                    {{ "procedure.choose_procedure_private" | translate }}
                </button>
            </div>
        </div>
    </div>
    <div>
        <div class="note" *ngIf="selectedServiceType?.internalFlowNotEdit">{{ "form.note_contracting_parties" | translate }}</div>
        <nz-table #partyRowTable nzBordered [nzShowPagination]="false"
        [nzFrontPagination]="false" class="ant-table-no-placeholder-border-bottom no-ant-table-placeholder">
            <thead>
                <tr style="background: #fafafa;" class="text-primary">
                    <!-- <th class="text-center" style="width: 50px !important;">
                        {{"enterprise_contract.panel_document.table_users.header.order" | translate}}
                    </th>
                    <th class="text-center" style="width: 100%;">
                        {{"enterprise_contract.panel_document.table_users.header.name" | translate}}
                    </th>
                    <th></th> -->
                    <td class="text-center" [attr.colspan]="setColspan(3)" style="padding: 0 !important;">
                        <div class="d-flex">
                          <div style="width: 50px; max-width: 50px; padding: 6px 8px; border-right: 1px solid #d9d9d9; border-bottom: 1px solid #d9d9d9;">
                            {{
                            "enterprise_contract.panel_document.table_users.header.order"
                            | translate
                            }}
                          </div>
                          <div class="d-flex justify-content-center" style="width: 100%; align-items: center; border-right: 1px solid #d9d9d9; border-bottom: 1px solid #d9d9d9;">
                            {{
                            "enterprise_contract.panel_document.table_users.header.name"
                            | translate
                            }}
                          </div>
                        </div>
                    </td>
                    <td style="border-right: 1px solid #d9d9d9; border-bottom: 1px solid #d9d9d9;"></td>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td [attr.colspan]="setColspan(3)" style="padding: 0 !important;">
                        <div class="d-flex align-items-center">
                            <div class="col-8 w-100 mat-panel-title_custom font-color-blue" style="padding-left: 10px;">
                                {{ "form.contract_approver" | translate}} &nbsp;
                            </div>
                            <div class="col-2 text-center mat-panel-title_custom font-color-blue d-flex justify-content-center"
                                   style="width: 160px !important; padding: 5px 10px; border-left: 1px solid #d9d9d9; line-height: 20px;">
                                {{"enterprise_contract.panel_document.table_parties.header.sig_cts" | translate}}
                            </div>
                            <div class="col-2 text-center mat-panel-title_custom font-color-blue d-flex justify-content-center"
                                style="width: 160px !important; padding: 5px 10px; border-left: 1px solid #d9d9d9; line-height: 20px;">
                                {{"enterprise_contract.panel_document.table_parties.header.display_signature" | translate}}
                            </div>
                        </div>
                    </td>
                    <td></td>
                </tr>

                <!-- Danh sách người dùng phê đuuyệt hợp đồng -->
                <tr *ngFor="let user of RECORD_USER_PERFORM_SIGN; let i = index" [hidden]="user.role === '1'">
                    <td class="text-center" class="text-center" [attr.colspan]="setColspan(3)" style="padding: 0 !important;">
                        <div class="d-flex">
                            <div class="col-8 d-flex" style="padding-left: 0;">
                              <div class="col-2" style="padding: 15px 0; border-right: 1px solid #d9d9d9; max-width: 80px;">
                                <nz-input-number [disabled]="selectedServiceType?.internalFlowNotEdit" class="td-nz-input" style="max-width: 60px;" [(ngModel)]="user.order" (ngModelChange)="onChangeOrderApproveSign()" [nzMin]="1"
                                [ngModelOptions]="{ standalone: true }"></nz-input-number> </div>
                              <div class="d-flex col-10" style="align-items: center; padding: 0 8px">
                                    <div class="editable-cell" *ngIf="user.userId != null">
                                      <div *ngIf="user.departmentName" class="row-icon department"><span
                                          class="material-icons">apartment</span>{{ user.departmentName }}</div>
                                      <div class="row-icon"><span class="material-icons" *ngIf="!user.departmentName">person</span>
                                        {{user.name}} - {{user.email}} <span *ngIf="user.userPosition">- {{user.userPosition}}</span></div>
                                    </div>
                              </div>
                            </div>
                            <div class="col-2 d-flex justify-content-center" style="width: 160px !important; padding: 5px 10px; border-left: 1px solid #d9d9d9; align-items: center;">
                              <label nz-checkbox [nzDisabled]="selectedServiceType?.internalFlowNotEdit" [(ngModel)]="user.isSignDigitalCertificate"
                                     (ngModelChange)="user.isSignDigitalCertificate ? user.signConfig.showImage = true : user.signConfig.showImage = false; changeCheckbox()"
                                     [ngModelOptions]="{ standalone: true }">
                              </label>
                            </div>
                            <div class="col-2 d-flex justify-content-center" style="width: 160px !important; padding: 5px 10px; border-left: 1px solid #d9d9d9; align-items: center;">
                              <ng-container *ngIf="user && user.isSignDigitalCertificate">
                                <label nz-checkbox [nzDisabled]="selectedServiceType?.internalFlowNotEdit" [ngModel]="user?.signConfig?.showImage"
                                  (ngModelChange)="user.signConfig.showImage = $event; changeDisplaySignature()"
                                  [ngModelOptions]="{ standalone: true }">
                                </label>
                              </ng-container>
                            </div>
                        </div>
                    </td>
                    <td class="text-center">
                        <ng-container *ngIf="!selectedServiceType?.internalFlowNotEdit">
                            <a *ngIf="user.userId != null" nz-popconfirm [nzIcon]="iconDel" nzPopconfirmTitle="{{
                                'popup.confirm_delete_user' | translate
                                }}" (nzOnConfirm)="onClickDeleteElementRecordUser(user.userId)"
                                            nzCancelText="{{ 'button.cancel' | translate }}" nzOkText="{{ 'button.ok' | translate }}">
                                <i class="fa fa-trash" aria-hidden="true"
                                    matTooltip="{{ 'tooltips.delete' | translate }}"></i>
                            </a>
                            <ng-template #iconDel>
                                <i class="text-primary" nz-icon nzType="warning" nzTheme="outline"></i>
                            </ng-template>
                        </ng-container>
                        <ng-container *ngIf="selectedServiceType?.internalFlowNotEdit">
                            <a *ngIf="user.userId != null"
                            >
                              <i class="fa fa-trash disable-delete" aria-hidden="true"></i>
                            </a>
                        </ng-container>
                    </td>
                </tr>

                <!-- Tìm kiếm người dùng phê duyệt hợp đồng -->
                <tr *ngIf="!isCheckApprover">
                    <td colspan="3" style="padding: 0 !important;">
                        <div class="d-flex">
                            <div class="col-8 d-flex" style="padding-left: 0;">
                                <div style="width: 86px; max-width: 86px; padding: 15px 8px; border-right: 1px solid #d9d9d9;">
                                </div>
                                <div class="d-flex justify-content-center"
                                    style="width: 100%; align-items: center; padding: 0 8px; height: 65px;">
                                    <div style="width: 100%;">
                                        <nz-input-group [nzSuffix]="suffixUserInput">
                                            <input nz-input
                                                [disabled]="selectedServiceType?.internalFlowNotEdit"
                                                [(ngModel)]="inputUserValue"
                                                (input)="onChangeUserSignSearch($event)"
                                                [nzAutocomplete]="autoUserSearching" [ngModelOptions]="{ standalone: true }"
                                                placeholder="{{ 'placeholder.name_email_and_posiotion' | translate }}"
                                                #autocompleteInput id="inputUser" />
                                            <nz-autocomplete #autoUserSearching>
                                                <nz-auto-option *ngFor="let user of filteredUserOptions"
                                                    (selectionChange)="autocompleteUserSelected($event, user)"
                                                    [nzValue]="''">
                                                    <div *ngIf="user.type === 'DEPARTMENT'" class="row-icon department">
                                                        <span class="material-icons">apartment</span>{{ user.departmentName
                                                        }}
                                                    </div>
                                                    <div class="row-icon user"
                                                        *ngIf="(user.type === 'DEPARTMENT' && user.representativeId) || user.type === 'USER'"
                                                        [class.disabled]="!user.representativeIsActive && user.type === 'DEPARTMENT'">
                                                        <span class="material-icons"
                                                            *ngIf="user.type === 'USER'">person</span> {{user.name}} -
                                                        {{user.email}} <span
                                                            *ngIf="!user.representativeIsActive && user.type === 'DEPARTMENT'">{{
                                                            "enterprise_contract.panel_document.table_users.representative_inactive"
                                                            | translate
                                                            }}</span> <span *ngIf="user.userPosition"> - {{user.userPosition}}</span>
                                                    </div>
                                                    <div class="row-icon disabled user"
                                                        *ngIf="!user.representativeId && user.type === 'DEPARTMENT'">
                                                        {{
                                                        "enterprise_contract.panel_document.table_users.no_representative_text"
                                                        | translate }}
                                                    </div>
                                                    <hr style="margin: 0; padding: 0" />
                                                </nz-auto-option>
                                            </nz-autocomplete>
                                        </nz-input-group>
                                        <ng-template #suffixUserInput>
                                            <nz-spin *ngIf="nzCheckLoadingUserSign" nzSimple
                                                [nzIndicator]="indicatorUserInput"></nz-spin>
                                        </ng-template>
                                        <ng-template #indicatorUserInput><i class="nz-icon-font" nz-icon nzType="loading"
                                                style="font-size: 24px"></i></ng-template>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex col-2" style="width: 160px !important; padding: 5px 10px; border-left: 1px solid #d9d9d9; align-items: center;"></div>
                            <div class="d-flex col-2" style="width: 160px !important; padding: 5px 10px; border-left: 1px solid #d9d9d9; align-items: center;"></div>
                        </div>
                    </td>
                     <td></td>
                </tr>
                <tr>
                    <td colspan="4">
                        <div style="padding-left: 10px; color: #4e73df; font-style: italic;">
                            {{ "form.user_signs_and_approves_the_contract" | translate}} &nbsp;
                        </div>
                    </td>
                </tr>
                <!-- Danh sách người dùng Ký đuuyệt hợp đồng -->
                <tr *ngFor="let user of RECORD_USER_PERFORM_SIGN; let i = index" [hidden]="user.role !== '1'">
                    <td class="text-center" colspan="3" style="padding: 0 !important;">
                        <div class="d-flex">
                            <div style="width: 86px; max-width: 86px; padding: 15px 8px; border-right: 1px solid #d9d9d9;">
                                1
                            </div>
                            <div class="d-flex" style="width: 100%; align-items: center;  padding: 0 8px">
                                <div class="editable-cell" *ngIf="user.userId != null">
                                    <div *ngIf="user.departmentName" class="row-icon department"><span
                                            class="material-icons">apartment</span>{{ user.departmentName }}</div>
                                    <div class="row-icon word-break-line text-left"><span class="material-icons"
                                            *ngIf="!user.departmentName">person</span>
                                        {{user.name}} - {{user.email}} <span *ngIf="user.userPosition">- {{user.userPosition}}</span></div>
                                </div>
                            </div>
                        </div>
                    </td>
                    <td class="text-center">
                        <ng-container *ngIf="!selectedServiceType?.internalFlowNotEdit">
                            <a *ngIf="user.userId != null" nz-popconfirm [nzIcon]="iconDel"
                                nzPopconfirmTitle="{{'popup.confirm_delete_user' | translate}}"
                                (nzOnConfirm)="onClickDeleteElementRecordUser(user.userId)"
                                nzCancelText="{{ 'button.cancel' | translate }}" nzOkText="{{ 'button.ok' | translate }}">
                                <i class="fa fa-trash" aria-hidden="true"
                                    matTooltip="{{ 'tooltips.delete' | translate }}"></i>
                            </a>
                            <ng-template #iconDel>
                                <i class="text-primary" nz-icon nzType="warning" nzTheme="outline"></i>
                            </ng-template>
                        </ng-container>
                        <ng-container *ngIf="selectedServiceType?.internalFlowNotEdit">
                            <a
                            >
                              <i class="fa fa-trash disable-delete" aria-hidden="true"></i>
                            </a>
                        </ng-container>
                    </td>
                </tr>

                <!-- Tìm kiếm người dùng Ký duyệt hợp đồng -->
                <tr *ngIf="!isUserSign">
                    <td colspan="3" style="padding: 0 !important;">
                        <div class="d-flex">
                            <div style="width: 86px; max-width: 86px; padding: 15px 8px; border-right: 1px solid #d9d9d9;">
                            </div>
                            <div class="d-flex justify-content-center"
                                style="width: 100%; align-items: center; padding: 0 8px; height: 65px;">
                                <div class="w-100">
                                    <nz-input-group [nzSuffix]="suffixUserInputs">
                                        <input nz-input
                                            [disabled]="selectedServiceType?.internalFlowNotEdit"
                                            [(ngModel)]="inputUserSignValue" (input)="onChangeUserSearch($event)"
                                            [nzAutocomplete]="autoUserSignSearching"
                                            [ngModelOptions]="{ standalone: true }"
                                            placeholder="{{ 'placeholder.name_email_and_posiotion' | translate }}"
                                            #autocompleteInput id="inputUserSign" />
                                        <nz-autocomplete #autoUserSignSearching>
                                            <nz-auto-option *ngFor="let user of filteredUserOptions"
                                                (selectionChange)="autocompleteUserSignSelected($event, user)"
                                                [nzValue]="''">
                                                <div *ngIf="user.type === 'DEPARTMENT'" class="row-icon department">
                                                    <span class="material-icons">apartment</span>{{ user.departmentName
                                                    }}
                                                </div>
                                                <div class="row-icon user"
                                                    *ngIf="(user.type === 'DEPARTMENT' && user.representativeId) || user.type === 'USER'"
                                                    [class.disabled]="!user.representativeIsActive && user.type === 'DEPARTMENT'">
                                                    <span class="material-icons word-break-line text-left"
                                                        *ngIf="user.type === 'USER'">person</span> {{user.name}} -
                                                    {{user.email}} <span
                                                        *ngIf="!user.representativeIsActive && user.type === 'DEPARTMENT'">{{
                                                        "enterprise_contract.panel_document.table_users.representative_inactive"
                                                        | translate
                                                        }}</span> <span *ngIf="user.userPosition"> - {{user.userPosition}}</span>
                                                </div>
                                                <div class="row-icon disabled user"
                                                    *ngIf="!user.representativeId && user.type === 'DEPARTMENT'">
                                                    {{
                                                    "enterprise_contract.panel_document.table_users.no_representative_text"
                                                    | translate }}
                                                </div>
                                                <hr style="margin: 0; padding: 0" />
                                            </nz-auto-option>
                                        </nz-autocomplete>
                                    </nz-input-group>
                                    <ng-template #suffixUserInputs>
                                        <nz-spin *ngIf="nzCheckLoadingUser" nzSimple [nzIndicator]="indicatorUserInput">
                                        </nz-spin>
                                    </ng-template>
                                    <ng-template #indicatorUserInput><i class="nz-icon-font" nz-icon nzType="loading"
                                            style="font-size: 24px"></i></ng-template>
                                </div>
                            </div>
                        </div>
                    </td>
                    <td></td>
                </tr>
            </tbody>
        </nz-table>
    </div>
</section>
